import React from 'react';
import { AxlInput, AxlPanel, AxlTextArea } from 'axl-reactjs-ui';

// styles
import styles, * as E from '../../styles';

export default class SingleOrderStepThree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      addNewPickupAdress: false
    }
  }
  render() {
    const { getFormError, getFormValue, handleInputForm } = this.props;

    return (
      <E.StepContainer>
        <E.Panel>
          <E.PanelTitle>{`Dropoff Information`}</E.PanelTitle>
          <E.PanelContent>
            <AxlPanel>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label isError={!!getFormError("dropoff_address.street")}>{`Address line 1`}<E.Text_4 isError={!!getFormError("dropoff_address.street")}>{` - required`}</E.Text_4></E.Label>
                  <AxlInput
                    fluid style={styles.input}
                    showError={false}
                    placeholder={`Street`}
                    onChange={handleInputForm}
                    name="dropoff_address.street"
                    error={getFormError("dropoff_address.street")}
                    value={getFormValue("dropoff_address.street")} />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Address line 2`}</E.Label>
                  <AxlInput
                    fluid style={styles.input}
                    placeholder={`Apt/suite/unit...`}
                    onChange={handleInputForm}
                    name="dropoff_address.street2"
                    value={getFormValue("dropoff_address.street2")} />
                </AxlPanel.Col>
              </AxlPanel.Row>
              <E.Row>
                <E.Col>
                  <E.Label isError={!!getFormError("dropoff_address.city")}>{`City`}<E.Text_4 isError={!!getFormError("dropoff_address.city")}>{` - required`}</E.Text_4></E.Label>
                  <AxlInput
                    type={`text`} fluid
                    placeholder={``}
                    showError={false}
                    onChange={handleInputForm}
                    name="dropoff_address.city"
                    error={getFormError("dropoff_address.city")}
                    value={getFormValue("dropoff_address.city")}
                    style={styles.input_2} />
                </E.Col>
                <E.Col>
                  <E.Label isError={!!getFormError("dropoff_address.state")}>{`State`}<E.Text_4 isError={!!getFormError("dropoff_address.state")}>{` - required`}</E.Text_4></E.Label>
                  <AxlInput
                    fluid type={`text`}
                    placeholder={``}
                    showError={false}
                    onChange={handleInputForm}
                    name="dropoff_address.state"
                    error={getFormError("dropoff_address.state")}
                    value={getFormValue("dropoff_address.state")}
                    style={styles.input_2} />
                </E.Col>
                <E.Col>
                  <E.Label isError={!!getFormError("dropoff_address.zipcode")}>{`Zipcode`}<E.Text_4 isError={!!getFormError("dropoff_address.zipcode")}>{` - required`}</E.Text_4></E.Label>
                  <AxlInput
                    fluid type={`text`}
                    placeholder={``}
                    showError={false}
                    onChange={handleInputForm}
                    name="dropoff_address.zipcode"
                    error={getFormError("dropoff_address.zipcode")}
                    value={getFormValue("dropoff_address.zipcode")}
                    style={styles.input_2} />
                </E.Col>
              </E.Row>
              <E.Row>
                <E.Col>
                  <E.Label>{`Latitude`}</E.Label>
                  <AxlInput
                    fluid type={`text`} disabled
                    placeholder={``}
                    onChange={handleInputForm}
                    name="dropoff_address.latitude"
                    error={getFormError("dropoff_address.latitude")}
                    value={getFormValue("dropoff_address.latitude")}
                    style={styles.input_2} />
                </E.Col>
                <E.Col>
                  <E.Label>{`Longitude`}</E.Label>
                  <AxlInput
                    fluid type={`text`} disabled
                    placeholder={``}
                    onChange={handleInputForm}
                    name="dropoff_address.longitude"
                    error={getFormError("dropoff_address.longitude")}
                    value={getFormValue("dropoff_address.longitude")}
                    style={styles.input_2} />
                </E.Col>
              </E.Row>
              <AxlPanel.Row style={styles.row}>
                <AxlPanel.Col style={styles.col}>
                  <E.Label>{`Drop-Off Note`}<E.I>{` - optional`}</E.I></E.Label>
                  <AxlTextArea
                    fluid style={styles.textarea}
                    placeholder={`Drop-off notes here...`}
                    name="dropoff_note"
                    error={getFormError("dropoff_note")}
                    value={getFormValue("dropoff_note")}
                    onChange={handleInputForm} />
                </AxlPanel.Col>
              </AxlPanel.Row>
            </AxlPanel>
          </E.PanelContent>
        </E.Panel>
      </E.StepContainer>
    );
  }
}
